import { ChevronDown, ChevronUp } from "lucide-react";
import React from "react";
import { Prettify } from "../../utils/types";
import { BaseButton } from "./BaseButton";
import { BaseButtonProps, ButtonVariant } from "./types";

export type ActionsButtonProps = Prettify<Omit<BaseButtonProps<"button">, "as" | "variant">> & {
    /**
     * Defines the displayable text for label.
     */
    title: string;
    /**
     * Defined if a chevron icon should be facing up (opened) or down (not opened).
     */
    opened: boolean;
    /**
     * Defines button variant.
     * @default "primary"
     */
    variant?: Exclude<ButtonVariant, "external">;
};

export const ActionsButton = React.forwardRef<HTMLButtonElement, ActionsButtonProps>(({ opened, ...props }, ref) => (
    <BaseButton {...props} as="button" endIcon={opened ? <ChevronUp /> : <ChevronDown />} ref={ref} />
));
